function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#929292",
  strokeWidth: 2,
  cx: 9.5,
  cy: 9.5,
  r: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#929292",
  transform: "rotate(-45 17.596 17.596)",
  x: 16.096,
  y: 12.596,
  width: 3,
  height: 10,
  rx: 1
}));

function SvgIcSearchFor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgIcSearchFor;